export var ActionTextType;
(function(ActionTextType) {
    ActionTextType["product"] = "product";
    ActionTextType["club"] = "club";
})(ActionTextType || (ActionTextType = {}));
